import React, { Component } from 'react';

import './PageContent.css';

export default class PageContent extends Component {
  render() {
    return (
      <div className="page-content">
        {this.props.children}
      </div>
    );
  }
}